import { useInfiniteQuery } from '@tanstack/react-query';

import { client } from '@/api/common';
import type { RentalLocation } from '@/api/reservations';

type Variables = { text?: string; enabled?: boolean };

type LocationsAvailablePage = {
  data: RentalLocation[];
  meta: {
    page: number;
    totalPages: number;
    totalCount: number;
  };
};

const fetchLocations = async ({
  pageParam,
  variables,
}: {
  pageParam: number;
  variables: Variables;
}) => {
  try {
    let params: Record<string, any> = {
      // sort: variables.sort,
    };

    if (variables.text) {
      params.text = variables.text;
    }

    params.page = pageParam;

    const response = await client.get('v2/rental_locations', {
      params: { ...params },
    });

    return response.data;
  } catch (error) {
    console.error('fetchLocations error:', error);
    throw error;
  }
};

export const usePaginatedLocations = (variables: Variables) => {
  const { enabled = true, ...queryVariables } = variables;

  return useInfiniteQuery({
    queryKey: ['paginated/locations', queryVariables],
    queryFn: ({ pageParam = 1 }) =>
      fetchLocations({
        pageParam,
        variables: queryVariables,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: LocationsAvailablePage) => {
      if (lastPage.meta.page >= lastPage.meta.totalPages) {
        return undefined;
      }
      return lastPage.meta.page + 1;
    },
    enabled: enabled,
  });
};
